import React from 'react'
import PropTypes from 'prop-types'
import { MsalProvider as DefaultProvider } from '@azure/msal-react'
import { PublicClientApplication } from '@azure/msal-browser'
import { getRuntimeEnv } from '../runtimeEnv'

const azureClientId = getRuntimeEnv('REACT_APP_AZURE_CLIENT_ID')
const azureTenantId = getRuntimeEnv('REACT_APP_AZURE_TENANT_ID')

if (!azureClientId || !azureTenantId) {
  console.error('Missing required MSAL environment variables: REACT_APP_AZURE_CLIENT_ID and/or REACT_APP_AZURE_TENANT_ID')
}

const msalConfig = {
  auth: {
    clientId: azureClientId,
    authority: `https://login.microsoftonline.com/${azureTenantId}/v2.0`,
    redirectUri: window.location.origin + '/auth/callback'
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false
  }
}
const msalInstance = new PublicClientApplication(msalConfig)

const MsalProvider = ({ children }) => {
  return <DefaultProvider instance={msalInstance}>{children}</DefaultProvider>
}

MsalProvider.propTypes = {
  children: PropTypes.element.isRequired
}

export default MsalProvider
